// extracted by mini-css-extract-plugin
export var cancelButton = "_ng-5";
export var content = "_ng-3";
export var createButton = "_ng-6";
export var drawerContainer = "_ng-0";
export var footer = "_ng-2";
export var header = "_ng-1";
export var orderFormColumn = "_ng-4";